module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/apelv0-a6fae2a96341ea291055e0d5ef8420bb.jpg";